import deepdash from 'deepdash'
import lodash from 'lodash'
const _ = deepdash(lodash)

export function disallowAdditionalProperties (schema: Record<string, unknown> | Array<unknown>): void {
  _.eachDeep(schema, (_value: any, key: string | number, obj: any) => {
    if (key === 'properties' && obj.additionalProperties === undefined) {
      obj.additionalProperties = false
    }
  })
}

export function removeDisallowAdditionalProperties (schema: Record<string, unknown> | Array<unknown>): void {
  _.eachDeep(schema, (_value: any, key: string | number, obj: any) => {
    if (key === 'properties' && obj.additionalProperties !== undefined) {
      delete obj.additionalProperties
    }
  })
}
